<div class="">
    <div *ngIf="isShowBannerSlider" class="HVB-contnet dynamic-banner-top-slider">
        <carousel>
            <ng-container *ngFor="let a of bannerList;">
                <slide>
                    <div class="banner-slider-image" [ngStyle]="{'background-image': 'url(' + a.video_banner_image + ')'}">
                    <!-- <img class="banner-slider" src="{{a.video_banner_image}}"
                        onError="this.src='assets/default-img1.jpg'" alt="first slide" class="banner-slider-image"> -->
                        <div class="myOverlay"></div>
                    <div class="carousel-caption  text-left banner-slider-container">
                        <div class="HVB-logo" style="min-height: 70px;">
                            <img *ngIf="a.isEvent !== 'upcoming' && a.isEvent !== 'vod' " class="organizationLogo" src="{{a.logo}}" onError="this.src='assets/default-img1.jpg'">
                            <!-- <span *ngIf="a.isEvent !== 'upcoming' && a.isEvent !== 'vod'" class="ml-10 new-heading">{{a.name}}</span> -->
                        </div>
                        <div *ngIf="a.isEvent !== 'upcoming' && a.isEvent !== 'vod'" class="new-heading">{{a.name}}</div>
                        <h2 *ngIf="a.stream_video_title && a.isEvent != 'channels' && a.stream_video_title !='Jamaican All-Stars Carnival Special'" class="new-heading">
                            {{a.stream_video_title}}
                            <span class="live-event" *ngIf="a.isEvent == 'live'">LIVE</span>
                        </h2>
                        <h2 *ngIf="a.stream_video_title && a.isEvent != 'channels' && a.stream_video_title =='Jamaican All-Stars Carnival Special'" class="new-heading carnival">
                            {{a.first_line}}<br>
                            <span class="fs-26">{{a.second_line}}</span>
                            <span class="live-event" *ngIf="a.isEvent == 'live'">LIVE</span>
                        </h2>
                        <div>
                            <p *ngIf="a.isEvent == 'organization'"  class="new-content mt-20" [innerHTML]="a?.banner_text"></p>
                            <p *ngIf="a.isEvent == 'channels'"  class="new-content mt-20" [innerHTML]="a?.performer_bio"></p>
                            <p *ngIf="a.isEvent == 'upcoming'"  class="new-content">{{a.publish_date_time}}</p>
                            <!-- <p *ngIf="a.short_description && a.isEvent != 'channels'">
                                    {{a?.short_description}}
                            </p> -->
                        </div>
                        <!-- <button mat-flat-button class="theme-btn1 mt-20" *ngIf="!userInfo.signedIn && a.isEvent == 'organization'"  routerLink="/{{a.organization_name}}">View</button> -->
                            <button mat-flat-button class="theme-btn1 mt-20" *ngIf="!userInfo.signedIn && (a.isEvent == 'upcoming' || a.isEvent == 'vod')" (click)="goToSignUp(a)">Buy Now</button>
                        <!-- <button mat-flat-button class="theme-btn1 mt-20" *ngIf="!userInfo.signedIn && a.isEvent == 'channels'" routerLink="/c/{{a.channel_name}}/profile">Sign Up</button> -->
                    </div>
                    </div>
                </slide>
            </ng-container>
        </carousel>
    </div>
    <div *ngIf="!isShowBannerSlider" style="background-size: cover;background-position: center center;padding: 30px 20px;text-align: center;" fxLayoutAlign="start center">
        <div style="width: 100%;" >
            <content-loading [width]="'width85Per'"></content-loading>
            <content-loading [width]="'width65Per'"></content-loading>
            <content-loading [width]="'width45Per'"></content-loading>
            <content-loading [width]="'width85Per'"></content-loading>
            <content-loading [width]="'width65Per'"></content-loading>
            <content-loading [width]="'width45Per'"></content-loading>
            <content-loading [width]="'width85Per'"></content-loading>
            <content-loading [width]="'width65Per'"></content-loading>
            <content-loading [width]="'width45Per'"></content-loading>
            <content-loading [width]="'width85Per'"></content-loading>
            <content-loading [width]="'width65Per'"></content-loading>
            <content-loading [width]="'width45Per'"></content-loading>
            <content-loading [width]="'width30Per'"></content-loading>
            <!-- <div class="HVB-logo"><img src="assets/c-logo.png"></div>
            <h2>Throwing DJ Parties</h2>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                industry's standard dummy text ever since the 1500s, when an </p> -->
        </div>
    </div>
    <!-- <div>
        <h1>Unlimited Events, Session
            and more</h1>
        <div class="subtext">Watch anywhere. Cancel anytime.</div>
        <button mat-flat-button class="theme-btn1" *ngIf="!userInfo.signedIn" (click)="openLogin()">Sign In</button>
    </div> -->
</div>
<div class="Landing-LiveEvents Slider1p-0" *ngIf="((liveUpcomingEvents && liveUpcomingEvents?.length > 0) || (trendingChannels && trendingChannels?.length > 0))">
    <!-- <div class="Hed1">Live Events</div>
    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>


    <div class="S1-container" *ngIf="isLoadingLiveEvent">
        <section class="loader-slider1 slider">
            <ng-container *ngFor="let a of [1,2,3,4,5,6]">
                <div class="slide Category">
                    <content-loading [width]="'width85Per'"></content-loading>
                    <content-loading [width]="'width65Per'"></content-loading>
                    <content-loading [width]="'width45Per'"></content-loading>
                    <content-loading [width]="'width85Per'"></content-loading>
                    <content-loading [width]="'width65Per'"></content-loading>
                    <content-loading [width]="'width45Per'"></content-loading>
                    <content-loading [width]="'width85Per'"></content-loading>
                    <content-loading [width]="'width65Per'"></content-loading>
                    <content-loading [width]="'width45Per'"></content-loading>
                    <content-loading [width]="'width85Per'"></content-loading>
                    <content-loading [width]="'width65Per'"></content-loading>
                    <content-loading [width]="'width45Per'"></content-loading>
                    <content-loading [width]="'width85Per'"></content-loading>
                    <content-loading [width]="'width65Per'"></content-loading>
                    <content-loading [width]="'width45Per'"></content-loading>
                    <content-loading [width]="'width85Per'"></content-loading>
                    <content-loading [width]="'width65Per'"></content-loading>
                    <content-loading [width]="'width45Per'"></content-loading>
                    <content-loading [width]="'width30Per'"></content-loading>
                </div>
            </ng-container>
        </section>
    </div> -->

    <!-- <div class="S1-container" [ngClass]="{'pb-60' : liveEventList}" *ngIf="!isLoadingLiveEvent && liveEventList">
        <section class="customer-logos slider">
            <ng-container *ngFor="let a of liveEventList;">
                <div class="slide Category" [ngStyle]="{'background-image': 'url(' + a.video_banner_image + ')'}"
                    (click)="redirectToUserHome(a)">
                    <div class="overlay"></div>
                    <div class="C-content">
                        {{a.stream_video_title | limitToEllipsis: 18}}
                    </div>
                </div>
            </ng-container>
        </section>
    </div> -->

    <!-- <ng-container *ngIf="categoryList && categoryList?.length > 0">
        <ng-container *ngFor="let a of categoryList;">
            <div class="Slider-section Slider1" *ngIf="a?.subcategory.length > 0">
                <div class="SS-head text-left"> {{a.category}} </div>
                <div class="S1-container">
                    <section class="channels-images-slider2 slider">
                        <ng-container *ngFor="let b of a.subcategory">
                            <div class="slide Channels"
                                [ngStyle]="{'background-image': 'url(' + b.category_image + ')'}"
                                (click)="goToCategory(a.category,b.subCategory)">
                                <div class="overlay"></div>
                                <div class="C-content">
                                    <div class="row align-items-center">
                                        <div class="col-10"> {{b.subCategory | limitToEllipsis: 15}} </div>
                                        <div class="col-2 text-right">
                                            <a href="#" class="Like active"><i class="fa fa-heart"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </section>
                </div>
            </div>
        </ng-container>
    </ng-container> -->
    <div  [ngClass]="{'bg-height': (liveUpcomingEvents && liveUpcomingEvents.length == 0)}">
        <ng-container *ngIf="isLoadingEvent">
            <div class="Slider-section Slider1">
                <div class="SS-head text-left mb-4">Live Events</div>
                <div class="S1-container">
                    <section class="loader-slider1 slider">
                        <ng-container *ngFor="let a of [1,2,3,4,5,6]">
                            <div class="slide Channels">
                                <content-loading [width]="'width85Per'"></content-loading>
                                <content-loading [width]="'width65Per'"></content-loading>
                                <content-loading [width]="'width45Per'"></content-loading>
                                <content-loading [width]="'width85Per'"></content-loading>
                                <content-loading [width]="'width65Per'"></content-loading>
                                <content-loading [width]="'width45Per'"></content-loading>
                                <content-loading [width]="'width85Per'"></content-loading>
                                <content-loading [width]="'width65Per'"></content-loading>
                                <content-loading [width]="'width45Per'"></content-loading>
                                <content-loading [width]="'width85Per'"></content-loading>
                                <content-loading [width]="'width65Per'"></content-loading>
                                <content-loading [width]="'width45Per'"></content-loading>
                                <content-loading [width]="'width30Per'"></content-loading>
                            </div>
                        </ng-container>
                    </section>
                </div>
            </div>
        </ng-container>        
        <ng-container *ngIf="liveUpcomingEvents && liveUpcomingEvents?.length > 0 && !isLoadingEvent">
            <div id="liveevents" class="Landing-banner-black pb-4">
                <div class="Slider-section Slider1">
                    <div class="txt-white-title mb-4">Live Events</div>
                    <div class="S1-container">
                        <section class="customer-logos slider channels-images-slider1">
                            <ng-container *ngFor="let a of liveUpcomingEvents">
                                <div class="slide Channels" (click)="goToSignUp(a)"
                                    [ngStyle]="{'background-image': 'url(' + a.video_thumbnail_image + ')'}">
                                    <div class="overlay"></div>
                                    <div class="C-content">
                                        <div class="row align-items-center">
                                            <div class="col-10">
                                                <div *ngIf="a.stream_video_title.length < 15">{{a.stream_video_title}}
                                                </div>
                                                <div *ngIf="a.stream_video_title.length >= 15"
                                                    matTooltipPosition="above" matTooltip="{{a.stream_video_title}}">
                                                    {{a.stream_video_title |limitTo:15}}...
                                                </div>
                                            </div>
                                            <div class="col-2 text-right">
                                                <!-- <a href="#" class="Like active"><i class="fa fa-heart"></i></a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </section>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="isLoadingChannel">
            <div class="Landing-banner-yellow">
                <div class="SS-head text-left mb-4">Trending Channels</div>
                <div class="S1-container">
                    <section class="loader-slider1 slider">
                        <ng-container *ngFor="let a of [1,2,3,4,5,6]">
                            <div class="slide Channels">
                                <content-loading [width]="'width85Per'"></content-loading>
                                <content-loading [width]="'width65Per'"></content-loading>
                                <content-loading [width]="'width45Per'"></content-loading>
                                <content-loading [width]="'width85Per'"></content-loading>
                                <content-loading [width]="'width65Per'"></content-loading>
                                <content-loading [width]="'width45Per'"></content-loading>
                                <content-loading [width]="'width85Per'"></content-loading>
                                <content-loading [width]="'width65Per'"></content-loading>
                                <content-loading [width]="'width45Per'"></content-loading>
                                <content-loading [width]="'width85Per'"></content-loading>
                                <content-loading [width]="'width65Per'"></content-loading>
                                <content-loading [width]="'width45Per'"></content-loading>
                                <content-loading [width]="'width30Per'"></content-loading>
                            </div>
                        </ng-container>
                    </section>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!isLoadingChannel && trendingChannels && trendingChannels?.length > 0">
            <div  id="trendingchannels" class="Landing-banner-yellow">
                <div class="Slider-section Slider1">
                    <div class="txt-white-title mb-4">Trending Channels</div>
                    <div class="S1-container">
                        <section class="channels-images-slider3 slider">
                            <ng-container *ngFor="let a of trendingChannels">
                                <div class="slide Channels" (click)="goToOrganization(a)"
                                    [ngStyle]="{'background-image': 'url(' + a.performer_details?.performer_profile_pic + ')'}">
                                    <div class="overlay"></div>
                                    <div class="C-content">
                                        <div class="row align-items-center">
                                            <div class="col-10">
                                                <div *ngIf="a.performer_details?.performer_display_name?.length < 15">
                                                    {{a.performer_details?.performer_display_name}}</div>
                                                <div *ngIf="a.performer_details?.performer_display_name?.length >= 15"
                                                    matTooltipPosition="above"
                                                    matTooltip="{{a.performer_details?.performer_display_name}}">
                                                    {{a.performer_details?.performer_display_name |limitTo:15}}...
                                                </div>
                                            </div>
                                            <div class="col-2 text-right">
                                                <!-- <a href="#" class="Like active"><i class="fa fa-heart"></i></a> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </section>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<!-- <div class="new-slider">
    <div class="row align-items-center">
        <div class="col-md-2"></div>
        <div class="col-12 col-md-5 pl-0">
            <carousel>
                <ng-container>
                    <slide>
                        <img src="assets/Post 7.jpg" alt="first slide" style="display: block; width: 100%;">
                    </slide>
                    <slide>
                        <img src="assets/Post 8.jpg" alt="first slide" style="display: block; width: 100%;">
                    </slide>
                    <slide>
                        <img src="assets/Post 9.jpg" alt="first slide" style="display: block; width: 100%;">
                    </slide>
                </ng-container>
            </carousel>
        </div>
        <div class="col-12 col-md-5 pl-50">
            <button mat-flat-button class="theme-btn1" *ngIf="!userInfo.signedIn" routerLink="signup">Watch
                more</button>
        </div>
    </div>
</div> -->
<!-- <div class="Landing-Partner">
    <div class="row align-items-center">
        <div class="col-12 col-md-6"></div>
        <div class="col-12 col-md-6">
            <h4>Partner with Arevea</h4>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and
                scrambled it to make a type specimen book. </p>
            <button mat-flat-button class="theme-btn1">Read More</button>
        </div>
    </div>
</div> -->
<div class="Landing-banner-yellow pb-60">
    <div class="txt-white-title mb-4">ARE YOU A CREATOR?</div>
    <div class="container">
        <div fxLayout="row wrap"  fxLayoutAlign="center center" fxLayoutGap="20px grid"
            fxLayoutGap.xs="0px grid" fxLayoutGap.sm="0px grid" class="w-100">

            <div fxFlex="33.3%" fxFlex.sm="30%" fxFlex.xs="100%">
                <div class="img-div">
                    <div class="banner1">
                        <div class="overlay">
                            <p class="fs-20p">Media and Entertainment</p>
                            <button class="btn-pink-round" (click)="goToCreator('')"><span class="sign-up-class">LEARN MORE</span></button>
                        </div>
                    </div>

                </div>

            </div>
            <div fxFlex="33.3%" fxFlex.sm="30%" fxFlex.xs="100%">
                <div class="img-div">
                    <div class="banner2">
                        <div class="overlay">
                            <p class="fs-20p">Arts and Culture</p>
                            <button class="btn-pink-round" style="cursor: default;"><span class="sign-up-class">COMING SOON</span></button>
                        </div>
                    </div>

                </div>

            </div>
            <div fxFlex="33.3%" fxFlex.sm="30%" fxFlex.xs="100%">
                <div class="img-div">
                    <div class="banner3">
                        <div class="overlay">
                            <p class="fs-20p">Corporate</p>
                            <button class="btn-pink-round" (click)="goToCreator('corporate')"><span class="sign-up-class">LEARN MORE</span></button>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>
    <!-- <div class="text-center pt-110"> <button mat-flat-button class="theme-btn1" routerLink="fan">Learn more</button></div> -->

</div>
<!-- <div class="Landing-banner-pink">
    <div class="p-postion ">
        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="30px grid"
        fxLayoutGap.xs="0" fxLayoutGap.sm="0px" class="w-100">
        <div fxFlex="15%" fxFlex.sm="30%">
            <div class="ml-4 dot-position"> <img src="../../../../../assets/homepage/dots.png" style="width: 95%;"></div>
        </div>
        <div fxFlex="45%" fxFlex.sm="30%">
            <div class="txt-white-title">ARE YOU A FAN?</div>
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="40px grid"
                fxLayoutGap.xs="0" fxLayoutGap.sm="0px" class="w-100">
                <div fxFlex="50%" fxFlex.sm="30%">
                    <div class="mb-4">
                        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="10px grid"
                        fxLayoutGap.xs="0" fxLayoutGap.sm="0px" class="w-100">
                        <div fxFlex="30%" fxFlex.sm="30%">
                            <img src="assets/homepage/icon1.png" class="icon-s-80">
                        </div>
                        <div fxFlex="70%" fxFlex.sm="30%">
                           <p class="icon-text">Engage with Creators & Fans</p> 
                        </div>
                    </div>
                    </div>
                 
                </div>
                <div fxFlex="50%" fxFlex.sm="30%">
                    <div class="mb-4">
                    <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="30px grid"
                        fxLayoutGap.xs="0" fxLayoutGap.sm="0px" class="w-100">
                        <div fxFlex="30%" fxFlex.sm="30%">
                            <img src="assets/homepage/icon2.png" class="icon-s-80">
                        </div>
                        <div fxFlex="70%" fxFlex.sm="30%">
                           <p class="icon-text">Contribute to creator causes</p> 
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="30px grid"
            fxLayoutGap.xs="0" fxLayoutGap.sm="0px" class="w-100">
            <div fxFlex="50%" fxFlex.sm="30%">
                <div class="mb-4">
                <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="10px grid"
                    fxLayoutGap.xs="0" fxLayoutGap.sm="0px" class="w-100">
                    <div fxFlex="30%" fxFlex.sm="30%">
                        <img src="assets/homepage/icon3.png" class="icon-s-80">
                    </div>
                    <div fxFlex="70%" fxFlex.sm="30%">
                       <p class="icon-text">High quality low latency</p> 
                    </div>
                </div>
                </div>
            </div>
            <div fxFlex="50%" fxFlex.sm="30%">
                <div class="mb-4">
                <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="30px grid"
                    fxLayoutGap.xs="0" fxLayoutGap.sm="0px" class="w-100">
                    <div fxFlex="30%" fxFlex.sm="30%">
                        <img src="assets/homepage/icon4.png" class="icon-s-80">
                    </div>
                    <div fxFlex="70%" fxFlex.sm="30%">
                       <p class="icon-text">Discover great live content</p> 
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div> <button class="btn-pink-round-border" routerLink="fan" >LEARN MORE</button></div>
        </div>
        <div fxFlex="40%" fxFlex.sm="30%">
            <div class="banner4"></div>
        </div>
    </div>
    </div>
</div> -->

<div class="Landing-banner-pink">
    <div class="container">
        <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px grid">
            <div fxFlex="50%" fxFlex.sm="50%" fxFlex.xs="100%">
                <div class="txt-white-title r-ryaf text-left ml-2 mb-2">ARE YOU A FAN?</div>
                <div fxLayout="row wrap" fxLayoutGap="10px grid" fxLayoutGap.xs="0" fxLayoutGap.sm="0px" class="w-100">
                        <div fxFlex="50%" fxFlex.sm="50%">
                            <div class="mb-4">
                                <div fxLayout="row wrap" fxLayoutGap="10px grid" fxLayoutGap.xs="0" fxLayoutGap.sm="0px"
                                    class="w-100">
                                    <div fxFlex="30%" fxFlex.sm="30%">
                                        <img src="assets/website/homepage/icon1.png" class="img-w">
                                    </div>
                                    <div fxFlex="70%" fxFlex.sm="70%">
                                        <p class="icon-text r-txt-icon">Engage with Creators & Fans </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div fxFlex="50%" fxFlex.sm="50%">
                            <div class="mb-4">
                                <div fxLayout="row wrap" fxLayoutGap="10px grid" fxLayoutGap.xs="0" fxLayoutGap.sm="0px"
                                    class="w-100">
                                    <div fxFlex="30%" fxFlex.sm="30%">
                                        <img src="assets/website/homepage/icon2.png" class="img-w">
                                    </div>
                                    <div fxFlex="70%" fxFlex.sm="70%">
                                        <p class="icon-text r-txt-icon">Contribute to creator causes</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div fxFlex="50%" fxFlex.sm="50%">
                            <div class="mb-4">
                                <div fxLayout="row wrap" fxLayoutGap="10px grid" fxLayoutGap.xs="0" fxLayoutGap.sm="0px"
                                    class="w-100">
                                    <div fxFlex="30%" fxFlex.sm="30%">
                                        <img src="assets/website/homepage/icon3.png" class="img-w">
                                    </div>
                                    <div fxFlex="70%" fxFlex.sm="70%">
                                        <p class="icon-text r-txt-icon">High quality low latency</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div fxFlex="50%" fxFlex.sm="50%">
                            <div class="mb-4">
                                <div fxLayout="row wrap" fxLayoutGap="10px grid" fxLayoutGap.xs="0" fxLayoutGap.sm="0px"
                                    class="w-100">
                                    <div fxFlex="30%" fxFlex.sm="30%">
                                        <img src="assets/website/homepage/icon4.png" class="img-w">
                                    </div>
                                    <div fxFlex="70%" fxFlex.sm="70%">
                                        <p class="icon-text r-txt-icon">Discover great live content</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-left ml-2"> <button class="btn-pink-round-border" routerLink="fan">LEARN
                        MORE</button></div>
            </div>
            <div fxFlex="50%" fxFlex.sm="50%" fxFlex.xs="100%">
                <div class="pt-60">
                    <div class="banner4"></div>
                </div>
            </div>
        </div>
        
    </div>
</div>
<div class="Landing-banner-black">
    <div class="container pt-60">
        <div class="row wrap" fxLayoutGap="30px grid" fxLayoutGap.xs="0px grid" fxLayoutAlign="center center">
            <div fxFlex="60%" fxFlex.xs="100%">
                <img src="assets/responsive-img.png" class="img-fluid">
            </div>
            <div fxFlex="40%" fxFlex.xs="100%">
                <div class="text-left">
                    <p class="txt-white-title r-txt text-left">CREATE AND<br> MONETIZE LIVE <br>EXPERIENCES FROM <br>
                        ANYWHERE</p>
                        <button mat-flat-button class="theme-btn1 mb-4" *ngIf="!userInfo.signedIn" routerLink="signup">Sign
                                up</button>
                </div>

            </div>
            <!-- <div class="col-md-1"></div> -->
        </div>
    </div>
</div>